import moment from 'moment';
import { IPaymentsByTimeOverviewChart } from '../../../types/dashboard';
import { IPagination } from '../../../types/pagination';
import { statusColor } from '../../../utils/statusColor';
import { DELETE_TIME_TRACKING_ENTRY_SUCCESS, UPDATE_TIME_TRACKING_ENTRY_SUCCESS } from '../../time-tracking/actions/constants';
import { TimeTrackingActions } from '../../time-tracking/actions/timeTrackingActions';
import { ITimeTracking } from '../../time-tracking/types/timeTracking';
import * as constants from '../actions/constants';
import { ProjectActions } from '../actions/projectActions';
import { ICustomer, IDepartmentTrend, IDepartmentTrendHours, IInsightsDepartmentHourUtilization, IProject, IProjectDepartmentsChartData, IProjectLabel, IProjectPhase, ITimeTrackingPermission, ITrackedHoursByDep, InsightsViewType, ViewType } from '../types/project';
import { ICostByMonths, ICostData, ICostsByPhaseChart, IDepartmentExpendituresByMonths, IDepartmentExpendituresTimeline, IExpendituresByLabels, IExpendituresByTasks, IInsightsDepartmentExpendituresTimelineChart, IProjectActivity, IProjectCostBurndownWidget, IProjectTimeTrackingLabel, IProjectTimeTrackingTask } from '../types/projectActivity';
import { _initialCostsByPhaseDataFixture } from './../../../fixtures/projectFixtures';
import { IBudgetCostTab, ICostBySupplier, IProjectBudgetChanges, IProjectFinancialCalculation, IProjectRecruitmentStatusChanges } from './../types/project';
import { IInsightsDepartmentExpendituresTimeline } from './../types/projectActivity';


export const _initialCustomer: ICustomer = {
  id: '',
  name: '',
  address: '',
  city: '',
  phone_number: '',
  email: ''
}

export const _initialTimeTrackingPerm: ITimeTrackingPermission = {
  project_id: '',
  task_permission: '',
  all_task_access: '',
  department_access: false,
  open_phase_access: false
}

export const _initialProjectFinancialCalculation: IProjectFinancialCalculation = {
  accounting_expenditures: 0,
  accounting_forecast: 0,
  activities_expenditures: 0
}

const _initialBudgetChartData: IProjectDepartmentsChartData = {
  categories: [],
  data: []
}

export const _initialProject: IProject = {
  id: '',
  name: '',
  customer: _initialCustomer,
  category: '',
  type: '',
  permissions: '',
  employees: [],
  start_date: null,
  end_date: null,
  budget: 0,
  phases: [],
  time_used: 0,
  budget_used: 0,
  invoiced: 0,
  health: '',
  healthColor: (health: string) => statusColor(health),
  activities: [],
  direct_costs: [],
  active: true,
  color: '',
  labels: [],
  time_tracking_perm: _initialTimeTrackingPerm,
  individual_employee_rate: [],
  project_billing_rate: 'individual',
  billing_procedure: 'billing_on_actual',
  cost_rate_billing: [],
  project_billing_rate_id: '',
  accounting: false,
  admins: [],
  offers: [],
  deleted_on: null,
  inactive_on: null,
  expenditures_budget_widget: 0,
  financial_calculation: _initialProjectFinancialCalculation,
  notifications: []
}

const _initialDepartmentByMonths: IDepartmentExpendituresByMonths = {
  month: -1,
  year: 0,
  cost: 0
}

export const _initialDepartmentTimeline: IDepartmentExpendituresTimeline = {
  name: '',
  data: [_initialDepartmentByMonths]
}

export const _initialDepartmentTimelinePagination: IPagination<IDepartmentExpendituresTimeline[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export const _initialInsightsDepartmentTimeline: IInsightsDepartmentExpendituresTimeline = {
  paginated_data: _initialDepartmentTimelinePagination,
  years: []
}

export const _initialInsightsDepartmentTimelineChart: IInsightsDepartmentExpendituresTimelineChart = {
  data: [_initialDepartmentTimeline],
  years: []
}

export const _initialExpendituresBurndown: IProjectCostBurndownWidget = {
  data: [],
  categories: [],
  colors: []
}

export const _initialProjectTimeTracking: IPagination<ITimeTracking[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export const _initialExpendituresByTasks: IExpendituresByTasks = {
  cost_name: '',
  cost: 0,
  labels: ['']
}

export const _initialExpendituresByLabels: IExpendituresByLabels = {
  name: '',
  color: '',
  total: 0
}

export const _initialExpendituresByTasksPagination: IPagination<IExpendituresByTasks[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export const _initialCostByMonthsData: ICostData = {
  name: '',
  cost: 0
}

export const _initialCostByMonths: ICostByMonths = {
  year: 0,
  month: 0,
  data: [_initialCostByMonthsData]
}

export const _initialIProjectTimeTrackingTask: IProjectTimeTrackingTask = {
  name: '',
  current_hours: 0,
  labels: ['']
}

export const _initialIProjectTimeTrackingLabel: IProjectTimeTrackingLabel = {
  name: '',
  color: '',
  total: 0,
  number_of_tasks: 0
}

export const _initialProjectTimeTrackingTasks: IPagination<IProjectTimeTrackingTask[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export const _initialProjectTimeTrackingLabels: IPagination<IProjectTimeTrackingLabel[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export const _initialDepTrendHours: IDepartmentTrendHours = {
  name: '',
  data: []
}

export const _initalDepTrend: IDepartmentTrend = {
  categories: [],
  trend_hours: [_initialDepTrendHours]
}

export const _initialInsightsDepartmentHoursUtilization: IInsightsDepartmentHourUtilization = {
  data: [],
  years: [],
  type: 'month'
}

export const checkProjectLoader = (state = false, action: ProjectActions): boolean => {
  switch (action.type) {
    case constants.SET_PROJECT_LOADER:
      return action.load

    default:
      return state
  }
}

export const project = (state: IProject = _initialProject, action: ProjectActions): IProject => {
  switch(action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return _initialProject

    case constants.GET_PROJECT_SUCCESS:
    case constants.CREATE_PROJECT_SUCCESS:
    case constants.UPDATE_PROJECT_SUCCESS:
    case constants.SELECT_PROJECT:
    case constants.UPDATE_PROJECT_BILLING_COSTS_SUCCESS:
      if (action.project.time_tracking_perm) {
        return {
          ...action.project,
          cost_rate_billing: action.project.cost_rate_billing.sort((a, b) => +a.id - +b.id),
          phases: [...action.project.phases].sort((a, b) => {
            const aStartDate = new Date(a.start_date).getTime()
            const bStartDate = new Date(b.start_date).getTime()
            const aEndDate = new Date(a.end_date).getTime()
            const bEndDate = new Date(b.end_date).getTime()
            return aStartDate !== bStartDate ?
              aStartDate - bStartDate
              : aEndDate - bEndDate
          }
        )}
      }
      return { ...action.project, time_tracking_perm: _initialTimeTrackingPerm}

    case constants.UPDATE_PHASES_SUCCESS:
      return {...state, phases: [...action.phases].sort((a, b) => a.start_date.toString().localeCompare(b.start_date.toString()))}

    case constants.UPDATE_LABELS_SUCCESS:
      return {...state, labels: [...action.labels].sort((a, b) => +a.id - +b.id)}

    default:
      return state
  }
}

export const budgetCostTabs = (state: IBudgetCostTab[] = [], action: ProjectActions): IBudgetCostTab[] => {
  switch(action.type) {
    case constants.GET_PROJECT_SUCCESS:
    case constants.CREATE_PROJECT_SUCCESS:
    case constants.UPDATE_PROJECT_SUCCESS:
    case constants.SELECT_PROJECT:
    case constants.UPDATE_PROJECT_BILLING_COSTS_SUCCESS:
      if (action.project.project_billing_rate && action.project.project_billing_rate.length !== 0) {
        return action.project.cost_rate_billing.sort((a, b) => +a.id - +b.id).map((c) => {
          return {name: c.name, key: c.name.toLowerCase(), id: +c.id}
        })
      }
      return []

    default:
      return state
  }
}

export const projectPlannerViewType = (state: ViewType = 'list', action: ProjectActions): ViewType => {
  switch (action.type) {
    case constants.SET_PROJECT_VIEW_TYPE:
      return action.viewType

    default:
      return state
  }
}

export const projectActivities = (state: IProjectActivity[] = [], action: ProjectActions): IProjectActivity[] => {
  switch(action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return []
    case constants.GET_PROJECT_SUCCESS:
    case constants.CREATE_PROJECT_SUCCESS:
    case constants.UPDATE_PROJECT_SUCCESS:
      if (action.project.activities) {
        return action.project.activities
      }
      return state

    default:
      return state
  }
}

export const projectInsightsViewType = (state: InsightsViewType = '', action: ProjectActions): InsightsViewType => {
  switch (action.type) {
    case constants.SET_INSIGHTS_VIEW_TYPE:
      return action.viewType

    default:
      return state
  }
}

export const projectPhaseListUpdate = (state: IProjectPhase[] = [], action: ProjectActions): IProjectPhase[] => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return []
    case constants.UPDATE_PHASES_SUCCESS:
      return action.phases

    default:
      return state
  }
}

export const generalFormActive = (state = false, action: ProjectActions): boolean => {
  switch (action.type) {
    case constants.SET_PROJECT_SETTINGS_GENERAL_FORM:
      return action.open

    default:
      return state
  }
}

export const projectLabelListUpdate = (state: IProjectLabel[] = [], action: ProjectActions): IProjectLabel[] => {
  switch (action.type) {
    case constants.UPDATE_LABELS_SUCCESS:
      return action.labels

    default:
      return state
  }
}

export const departmentCostsChartData = (state: IProjectDepartmentsChartData = _initialBudgetChartData, action: ProjectActions): IProjectDepartmentsChartData => {
  switch (action.type) {
    case constants.GET_DEPARTMENT_COSTS_CHART_DATA_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const departmentCostTrendCurve = (state: IInsightsDepartmentExpendituresTimelineChart = _initialInsightsDepartmentTimelineChart, action: ProjectActions): IInsightsDepartmentExpendituresTimelineChart => {
  switch (action.type) {
    case constants.GET_DEPARTMENT_COST_TREND_CURVE_DATA_SUCCESS:
      return action.depExpenditures

    default:
      return state
  }
}

export const departmentTimeline = (state: IInsightsDepartmentExpendituresTimelineChart = _initialInsightsDepartmentTimelineChart, action: ProjectActions): IInsightsDepartmentExpendituresTimelineChart => {
  switch (action.type) {
    case constants.GET_DEPARTMENT_EXPENDITURES_TIMELINE_SUCCESS:
      return action.depExpenditures

    default:
      return state
  }
}

export const departmentTimelinePagination = (state: IInsightsDepartmentExpendituresTimeline = _initialInsightsDepartmentTimeline, action: ProjectActions): IInsightsDepartmentExpendituresTimeline => {
  switch (action.type) {
    case constants.GET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINES_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const paginatedDepartmentTimelineActivePage = (state = 1, action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINES_ACTIVE_PAGE:
      return action.page

    // reset page to 1 after project change
    case constants.GET_PROJECT_SUCCESS:
      return 1

    default:
      return state
  }
}

export const expendituresBurndown = (state: IProjectCostBurndownWidget = _initialExpendituresBurndown, action: ProjectActions): IProjectCostBurndownWidget => {
  switch (action.type) {
    case constants.GET_PROJECT_EXPENDITURES_BURNDOWN_SUCCESS:
      return action.expenditures

    default:
      return state
  }
}

export const projectTimeTracking = (state: ITimeTracking[] = [], action: ProjectActions | TimeTrackingActions): ITimeTracking[] => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return []
    case UPDATE_TIME_TRACKING_ENTRY_SUCCESS:
      return state.map((entry)=> {
        if(entry.id === action.timeTrackingEntry.id) {
          return {...action.timeTrackingEntry}
        }
        return entry
      })
    case DELETE_TIME_TRACKING_ENTRY_SUCCESS:
      return state.filter((entry) => entry.id !== action.timeTrackingEntry.id)

    case constants.GET_PROJECT_TIME_TRACKING_SUCCESS:
      return action.timeTracking

    default:
      return state
  }
}

export const projectTimeTrackingPagination = (state: IPagination<ITimeTracking[]> = _initialProjectTimeTracking, action: ProjectActions | TimeTrackingActions): IPagination<ITimeTracking[]> => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return _initialProjectTimeTracking
    case UPDATE_TIME_TRACKING_ENTRY_SUCCESS:
      return {...state, results: state.results.map((entry)=> {
        if(entry.id === action.timeTrackingEntry.id) {
          return {...action.timeTrackingEntry}
        }
        return entry
      })}
    case DELETE_TIME_TRACKING_ENTRY_SUCCESS:
      return { ...state, results: state.results.filter((entry) => entry.id !== action.timeTrackingEntry.id) }
    case constants.GET_PAGINATED_TIME_TRACKING_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const paginatedProjectTimeTrackingActivePage = (state = 1, action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_TIME_TRACKING_ACTIVE_PAGE:
      return action.page

    // reset page to 1 after project change
    case constants.GET_PROJECT_SUCCESS:
      return 1

    default:
      return state
  }
}

export const searchProjectTimeTracking = (state: Record<string, string> = { search: '' }, action: ProjectActions): Record<string, string>  => {
  switch (action.type) {
    case constants.SEARCH_PROJECT_TIME_TRACKING:
      return action.queryParams

    default:
      return state
  }
}

export const expendituresByLabels = (state: IExpendituresByLabels[] = [_initialExpendituresByLabels], action: ProjectActions): IExpendituresByLabels[] => {
  switch (action.type) {
    case constants.GET_EXPENDITURES_BY_LABELS_SUCCESS:
      return action.labels

    default:
      return state
  }
}

export const expendituresByTasks = (state: IExpendituresByTasks[] = [_initialExpendituresByTasks], action: ProjectActions): IExpendituresByTasks[] => {
  switch (action.type) {
    case constants.GET_EXPENDITURES_BY_TASKS_SUCCESS:
      return action.tasks

    default:
      return state
  }
}

export const expendituresByTasksPagination = (state: IPagination<IExpendituresByTasks[]> = _initialExpendituresByTasksPagination, action: ProjectActions): IPagination<IExpendituresByTasks[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_EXPENDITURES_BY_TASKS_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const paginatedExpendituresByTasksActivePage = (state = 1, action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_EXPENDITURES_BY_TASKS_ACTIVE_PAGE:
      return action.page

    // reset page to 1 after project change
    case constants.GET_PROJECT_SUCCESS:
      return 1

    default:
      return state
  }
}

export const costByMonths = (state: ICostByMonths[] = [_initialCostByMonths], action: ProjectActions): ICostByMonths[] => {
  switch (action.type) {
    case constants.GET_COST_BY_MONTHS_SUCCESS:
      return action.costs

    default:
      return state
  }
}

export const projectTimeTrackingLabels = (state: IProjectTimeTrackingLabel[] = [], action: ProjectActions): IProjectTimeTrackingLabel[] => {
  switch (action.type) {
    case constants.GET_PROJECT_TIME_TRACKING_LABELS_SUCCESS:
      return action.labels

    default:
      return state
  }
}

export const projectTimeTrackingLabelsPagination = (state: IPagination<IProjectTimeTrackingLabel[]> = _initialProjectTimeTrackingLabels, action: ProjectActions): IPagination<IProjectTimeTrackingLabel[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_PROJECT_TIME_TRACKING_LABELS_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const paginatedProjectTimeTrackingLabelsActivePage = (state = 1, action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_PROJECT_TIME_TRACKING_LABELS_ACTIVE_PAGE:
      return action.page

    // reset page to 1 after project change
    case constants.GET_PROJECT_SUCCESS:
      return 1

    default:
      return state
  }
}

export const projectTimeTrackingTasks = (state: IProjectTimeTrackingTask[] = [], action: ProjectActions): IProjectTimeTrackingTask[] => {
  switch (action.type) {
    case constants.GET_PROJECT_TIME_TRACKING_TASKS_SUCCESS:
      return action.timeTracking

    default:
      return state
  }
}

export const sortTimeTrackingReport = (state: { name: string, direction: string} = { name: '', direction: ''}, action: ProjectActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.SORT_TIME_TRACKING_REPORT:
      return action.sort

    default:
      return state
  }
}


export const projectProjectTimeTrackingTasksPagination = (state: IPagination<IProjectTimeTrackingTask[]> = _initialProjectTimeTrackingTasks, action: ProjectActions): IPagination<IProjectTimeTrackingTask[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_PROJECT_TIME_TRACKING_TASKS_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const paginatedProjectTimeTrackingTasksActivePage = (state = 1, action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_PROJECT_TIME_TRACKING_TASKS_ACTIVE_PAGE:
      return action.page

    // reset page to 1 after project change
    case constants.GET_PROJECT_SUCCESS:
      return 1

    default:
      return state
  }
}

export const costByPhases = (state: ICostsByPhaseChart = _initialCostsByPhaseDataFixture, action: ProjectActions): ICostsByPhaseChart => {
  switch (action.type) {
    case constants.GET_COST_BY_PHASES_SUCCESS:
      return action.costs

    default:
      return state
  }
}

export const searchDepCostUtilization = (state = { search: '' }, action: ProjectActions): { search: string } => {
  switch (action.type) {
    case constants.SEARCH_DEPARTMENT_COST_UTILIZATION:
      return action.filter

    default:
      return state
  }
}

export const searchExpendituresByTasks = (state = { search: '' }, action: ProjectActions): { search: string } => {
  switch (action.type) {
    case constants.SEARCH_EXPENDITURES_BY_TASKS:
      return action.filter

    default:
      return state
  }
}

export const depHoursUtil = (state: IInsightsDepartmentHourUtilization = _initialInsightsDepartmentHoursUtilization, action: ProjectActions): IInsightsDepartmentHourUtilization => {
  switch (action.type) {
    case constants.GET_DEP_HOURS_UTIL_SUCCESS:
      return action.departments

    default:
      return state
  }
}

export const depTrendHours = (state: IDepartmentTrend = _initalDepTrend, action: ProjectActions): IDepartmentTrend => {
  switch (action.type) {
    case constants.GET_DEP_TREND_HOURS_SUCCESS:
      return action.departments

    default:
      return state
  }
}

export const trackedHoursByDep = (state: ITrackedHoursByDep[] = [], action: ProjectActions): ITrackedHoursByDep[] => {
  switch (action.type) {
    case constants.GET_TRACKED_HOURS_BY_DEP_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const projectBudgetChanges = (state: IProjectBudgetChanges[] = [], action: ProjectActions): IProjectBudgetChanges[] => {
  switch (action.type) {
    case constants.GET_BUDGET_CHANGES_SUCCESS:
    case constants.UPDATE_BUDGET_CHANGES_SUCCESS:
      return action.budgets

    default:
      return state
  }
}

export const costsBySupplier = (state: ICostBySupplier[] = [], action: ProjectActions): ICostBySupplier[] => {
  switch (action.type) {
    case constants.GET_COST_BY_SUPPLIER_SUCCESS:
      return action.costs

    default:
      return state
  }
}

export const costsBySelectedSupplier = (state = '', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_COST_BY_SUPPLIER:
      return action.value

    default:
      return state
  }
}

export const customers = (state: ICustomer[] = [], action: ProjectActions): ICustomer[] => {
  switch (action.type) {
    case constants.GET_CUSTOMERS_SUCCESS:
      return action.customers

    default:
      return state
  }
}

export const paymentsByTime = (state: IPaymentsByTimeOverviewChart = {categories: [], data: []}, action: ProjectActions): IPaymentsByTimeOverviewChart => {
  switch (action.type) {
    case constants.GET_PAYMENTS_BY_TIME_CHART_DATA_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const paymentsByTimePeriod = (state = 'month', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_PAYMENTS_BY_TIME_PERIOD:
      return action.period

    default:
      return state
  }
}

export const paymentsByTimeYear = (state = moment().year(), action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_YEAR_PAYMENTS_BY_TYPE:
      return action.year

    default:
      return state
  }
}

export const paymentForecast = (state: IPaymentsByTimeOverviewChart = {categories: [], data: []}, action: ProjectActions): IPaymentsByTimeOverviewChart => {
  switch (action.type) {
    case constants.GET_PAYMENT_FORECAST_CHART_DATA_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const paymentForecastTimePeriod = (state = 'month', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_PAYMENT_FORECAST_TIME_PERIOD:
      return action.period

    default:
      return state
  }
}

export const paymentForecastYear = (state = moment().year(), action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_YEAR_PAYMENT_FORECAST:
      return action.year

    default:
      return state
  }
}

export const receiptForecast = (state: IPaymentsByTimeOverviewChart = {categories: [], data: []}, action: ProjectActions): IPaymentsByTimeOverviewChart => {
  switch (action.type) {
    case constants.GET_RECEIPT_FORECAST_CHART_DATA_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const receiptForecastTimePeriod = (state = 'month', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_RECEIPT_FORECAST_TIME_PERIOD:
      return action.period

    default:
      return state
  }
}

export const receiptForecastYear = (state = moment().year(), action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_YEAR_RECEIPT_FORECAST:
      return action.year

    default:
      return state
  }
}

export const expenditurePhasing = (state: IPaymentsByTimeOverviewChart = {categories: [], data: []}, action: ProjectActions): IPaymentsByTimeOverviewChart => {
  switch (action.type) {
    case constants.GET_EXPENDITURE_PHASING_CHART_DATA_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const expenditurePhasingTimePeriod = (state = 'month', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_EXPENDITURE_PHASING_TIME_PERIOD:
      return action.period

    default:
      return state
  }
}

export const expenditurePhasingYear = (state = moment().year(), action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_YEAR_EXPENDITURE_PHASING:
      return action.year

    default:
      return state
  }
}

export const depCostTimePeriod = (state = 'month', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_TIME_PERIOD_DEP_COST:
      return action.period

    default:
      return state
  }
}

export const depCostYear = (state = moment().year(), action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_YEAR_DEP_COST:
      return action.year

    default:
      return state
  }
}

export const depCostType = (state = 'month', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_TYPE_DEP_COST:
      return action.selected

    default:
      return state
  }
}

export const projCostDevYear = (state = moment().year(), action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_YEAR_PROJ_COST_DEV:
      return action.year

    default:
      return state
  }
}

export const projCostDevType = (state = 'month', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_TYPE_PROJ_COST_DEV:
      return action.selected

    default:
      return state
  }
}

export const projectRecruitmentStatusChanges = (state: IProjectRecruitmentStatusChanges[] = [], action: ProjectActions): IProjectRecruitmentStatusChanges[] => {
  switch (action.type) {
    case constants.GET_RECRUITMENT_STATUS_CHANGES_SUCCESS:
    case constants.UPDATE_RECRUITMENT_STATUS_CHANGES_SUCCESS:
      return action.status

    default:
      return state
  }
}

export const costDevelopment = (state: IPaymentsByTimeOverviewChart = { categories: [], data: [] }, action: ProjectActions): IPaymentsByTimeOverviewChart => {
  switch (action.type) {
    case constants.GET_COST_DEVELOPMENT_CHART_DATA_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const recruitmentCosts = (state: IPaymentsByTimeOverviewChart = { categories: [], data: [] }, action: ProjectActions): IPaymentsByTimeOverviewChart => {
  switch (action.type) {
    case constants.GET_RECRUITMENT_STATUS_CHART_DATA_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const recruitmentCostsYear = (state = moment().year(), action: ProjectActions): number => {
  switch (action.type) {
    case constants.SET_YEAR_RECRUITMENT_COSTS:
      return action.year

    default:
      return state
  }
}

export const recruitmentCostsType = (state = 'month', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_TYPE_RECRUITMENT_COSTS:
      return action.selected

    default:
      return state
  }
}

export const costDevelopmentStatus = (state = 'real_time', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_COST_DEVELOPMENT_STATUS:
      return action.status

    default:
      return state
  }
}
export const recruitmentType = (state = 'patients', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_RECRUITMENT_TYPE:
      return action.recruitmentType

    default:
      return state
  }
}

export const marginDevelopment = (state: IPaymentsByTimeOverviewChart = { categories: [], data: [] }, action: ProjectActions): IPaymentsByTimeOverviewChart => {
  switch (action.type) {
    case constants.GET_MARGIN_DEVELOPMENT_CHART_DATA_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const restrictedPhases = (state: number[] = [], action: ProjectActions): number[] => {
  switch (action.type) {
    case constants.GET_RESTRICTED_PHASES_SUCCESS:
      return action.phases

    default:
      return state
  }
}

export const marginDevelopmentType = (state = 'month', action: ProjectActions): string => {
  switch (action.type) {
    case constants.SET_TYPE_MARGIN_DEVELOPMENT:
      return action.selected

    default:
      return state
  }
}
